import { render } from "./PopUp.vue?vue&type=template&id=f8cec242&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=f8cec242&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8cec242"]])

export default __exports__